import React, { useState, useRef } from 'react';
import { Card } from 'antd';
import {
    PlayCircleFilled,
    ExpandAltOutlined,
} from '@ant-design/icons';

const VideoPlayer = ({ url, isCustomerMessage }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const [showControls, setShowControls] = useState(false);
    const videoRef = useRef(null);
    const containerRef = useRef(null);

    const handlePlayPause = () => {
        if (videoRef.current) {
            if (isPlaying) {
                videoRef.current.pause();
            } else {
                videoRef.current.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    const toggleFullscreen = async (e) => {
        e.stopPropagation();
        if (!document.fullscreenElement) {
            try {
                await videoRef.current.requestFullscreen();
            } catch (err) {
                console.error('Error attempting to enable fullscreen:', err);
            }
        } else {
            await document.exitFullscreen();
        }
    };

    const handleVideoClick = (event) => {
        event.stopPropagation();
        handlePlayPause();
    };

    return (
        <Card
            size="small"
            bordered={false}
            ref={containerRef}
            bodyStyle={{ padding: 0 }}
            style={{
                width: '100%',
                maxWidth: 300,
                borderRadius: 8,
                background: isCustomerMessage ? '#f0f2f5' : '#e6f7ff',
                overflow: 'hidden'
            }}
        >
            <div
                style={{
                    position: 'relative',
                    cursor: 'pointer',
                }}
                onMouseEnter={() => setShowControls(true)}
                onMouseLeave={() => setShowControls(false)}
                onClick={handleVideoClick}
            >
                <video
                    ref={videoRef}
                    src={url}
                    style={{
                        width: '100%',
                        display: 'block',
                        borderRadius: 8,
                    }}
                    onEnded={() => setIsPlaying(false)}
                />

                {/* Play button overlay (only shows when video is paused) */}
                {!isPlaying && (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'white',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        borderRadius: '50%',
                        padding: 4
                    }}>
                        <PlayCircleFilled style={{ fontSize: 40 }} />
                    </div>
                )}

                {/* Fullscreen button (shows on hover) */}
                {showControls && (
                    <div
                        style={{
                            position: 'absolute',
                            top: 8,
                            insetInlineEnd: 8,
                            color: 'white',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            borderRadius: '50%',
                            padding: 6,
                            cursor: 'pointer'
                        }}
                        onClick={toggleFullscreen}
                    >
                        <ExpandAltOutlined style={{ fontSize: 16 }} />
                    </div>
                )}
            </div>
        </Card>
    );
};

export default VideoPlayer;
